import Cookies from "js-cookie";
import { CheckoutPlan, decorateUrlWithUTMParams } from "../LandingPage";
import { getInternalCoreEndpoint } from "../utils";
import { sha256 } from "js-sha256";
import { User } from "../types";
import { LOCAL_STORAGE_SESSION_IDENTITY_SESSION_ID_KEY } from "./useAnswerTracker";

export function getPlanPromotionCode(plan?: CheckoutPlan) {
  if (plan?.promotionCode) return plan.promotionCode;
  if (plan?.id === "serious") return "SPECIAL-20";
  if (plan?.id === "committed") return "SPECIAL20";
  return undefined;
}

export function createGetClientSecretPromise(
  plan?: CheckoutPlan,
  eventID?: string,
  user?: User,
  isNoTrialVariation = true
) {
  const mode = "web";
  const subscriptionPriceId = plan?.priceId ?? "";
  const unlockProductId = plan?.unlockProductId ?? "";
  const trialProductId = plan?.trialProductId ?? "";
  const promotionCode = getPlanPromotionCode(plan);

  const amplitudeId = Cookies.get("bws_amplitude_device_id");
  const sessionIdentitySessionId = localStorage.getItem(
      LOCAL_STORAGE_SESSION_IDENTITY_SESSION_ID_KEY
  );

  const urlObj = new URL(
    isNoTrialVariation
      ? `${getInternalCoreEndpoint()}/internal/public/checkout/${mode}/create-subscription/${subscriptionPriceId}/${unlockProductId}`
      : `${getInternalCoreEndpoint()}/internal/public/checkout/${mode}/create-trial/${subscriptionPriceId}/${unlockProductId}/${trialProductId}`
  );

  if (isNoTrialVariation && promotionCode) {
    urlObj.searchParams.set("promotion_code", promotionCode);
    urlObj.searchParams.set("pricing_variant", "no_trial");
  }
  urlObj.searchParams.set("ui_mode", "custom");
  urlObj.searchParams.set("tos_shown", "false");

  if (user?.email) {
    urlObj.searchParams.set("email", sha256(user.email));
  }

  if (user?.name) {
    urlObj.searchParams.set("name", user.name);
  }

  if (amplitudeId) {
    urlObj.searchParams.set("amplitudeId", amplitudeId);
  }

  if (eventID) {
      urlObj.searchParams.set("fb_event_id", eventID);
  }

  if (sessionIdentitySessionId) {
      urlObj.searchParams.set(
          "session_identity_session_id",
          sessionIdentitySessionId
      );
  }

  decorateUrlWithUTMParams(urlObj);

  return () => {
    return fetch(urlObj.toString(), {
      method: "GET",
    })
      .then((res) => res.json())
      .then((data) => data.client_secret);
  };
}
